import { create } from 'zustand'

interface ThemeState {
  mode: 'light' | 'dark'
  toggle: () => void
  setMode: (mode: 'light' | 'dark') => void
}

export const useThemeStore = create<ThemeState>((set, get) => ({
  mode: 'light',
  toggle: () => {
    set({ mode: get().mode === 'light' ? 'dark' : 'light' })
  },
  setMode: (mode: 'light' | 'dark') => {
    document.documentElement.className = mode
    set({ mode })
  },
}))
